<template>
  <div class="separator">
    <div class="separator__left"></div>
    <div v-if="$slots.default" class="separator__center"><slot /></div>
    <div class="separator__right"></div>
  </div>
</template>
<script>
export default {
  name: "sep"
};
</script>
<style lang="scss">
.separator {
  display: flex;
  align-items: center;
  margin: 40px 0;
  &__left,
  &__right {
    flex-grow: 1;
    border-bottom: 1px solid $light-gray;
  }
  &__center {
    padding: 0 10px;
  }
}
</style>
